
export default {

    cutText(excerpt, length, ender) {
        var isArr = Array.isArray(length),
            min = isArr ? length[0] : length,
            max = isArr ? length[1] : length;
        if( !excerpt || excerpt.length < max ) return excerpt;
        if( !isArr ) return excerpt.substring(0, max) + (ender ? ender : "...");
        var firstSpaceinRange = excerpt.substr(min, max-min).lastIndexOf(' '),
            breakChar = min + firstSpaceinRange;
        return excerpt.substr(0, breakChar) + (ender ? ender : "...");
    },

}



// WEBPACK FOOTER //
// ./src/js/services/textedit.js